window.cameraPermissionCallback = {
  onCameraPermissionRejected() {
    if (window.vueRoot) {
      window.vueRoot.$emit('camera-permission-rejected')
    }
  },
  onCameraPermissionGranted() {
    if (window.vueRoot) {
      window.vueRoot.$emit('camera-permission-granted')
    }
  }
}
